/* unplugin-vue-components disabled */import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../assets/images/weixing.png';
import _imports_1 from '../assets/images/weixingCss.png';
import _imports_2 from '../assets/images/index-left-icon.png';
const _hoisted_1 = {
  class: "home viewer"
};
const _hoisted_2 = {
  key: 0,
  class: "weiRight"
};
const _hoisted_3 = {
  class: "imgBox"
};
const _hoisted_4 = {
  class: "bottomCss"
};
const _hoisted_5 = {
  class: "inputsearch"
};
const _hoisted_6 = {
  class: "tuceng"
};
const _hoisted_7 = {
  key: 1,
  class: "leftContent"
};
const _hoisted_8 = {
  class: "dialog-content"
};
const _hoisted_9 = {
  key: 0,
  class: "weather-panel"
};
const _hoisted_10 = {
  class: "weather-item"
};
const _hoisted_11 = {
  class: "value"
};
const _hoisted_12 = {
  class: "weather-item"
};
const _hoisted_13 = {
  class: "value"
};
const _hoisted_14 = {
  class: "weather-item"
};
const _hoisted_15 = {
  class: "value"
};
const _hoisted_16 = {
  class: "weather-item"
};
const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  class: "weather-item"
};
const _hoisted_19 = {
  class: "value"
};
const _hoisted_20 = {
  class: "weather-item"
};
const _hoisted_21 = {
  class: "value"
};
const _hoisted_22 = {
  class: "weather-item"
};
const _hoisted_23 = {
  class: "value"
};
const _hoisted_24 = {
  class: "weather-item"
};
const _hoisted_25 = {
  class: "value"
};
const _hoisted_26 = {
  class: "weather-item"
};
const _hoisted_27 = {
  class: "value"
};
const _hoisted_28 = {
  class: "weather-item"
};
const _hoisted_29 = {
  class: "value"
};
const _hoisted_30 = {
  class: "weather-item"
};
const _hoisted_31 = {
  class: "value"
};
const _hoisted_32 = {
  class: "weather-item"
};
const _hoisted_33 = {
  class: "value"
};
const _hoisted_34 = {
  class: "video-box"
};
const _hoisted_35 = {
  key: 0,
  class: "no-stream"
};
import { getDicts } from "@/api/system/dict/data";
import { getHomeList } from "@/api/homepage/homepage";
import { useRouter } from 'vue-router';
import { deviceVideoPlay, getLastPoleWeather } from "@/api/base/device";
import usePermissionStore from "@/store/modules/permission";
import Player from "@/components/jessibuca/index.vue";
import { getTasking } from "@/api/base/taskmanager";
export default {
  __name: 'index',
  setup(__props) {
    const permissionStore = usePermissionStore();
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const searchkey = ref("");
    const devicesOptions = ref([]);
    const currentRow = ref({});
    const checkedTypes = ref(['0', '1', '2', '3', '4', '12', '13', '14']);
    //卫星显示
    const cVisible = ref(false);
    //卫星闪烁显示
    const show = ref(true);
    const map = ref({});
    const view = ref({});
    let _view = null;
    //const token = ref("0be355e9432deddfa8a6b4178faf3f65")
    const token = ref("436ce7e50d27eede2f2929307e6b33c0");
    const video = ref({
      // 是否显示弹出层
      open: false,
      // 弹出层标题
      title: '',
      // 视频流的地址
      url: null
    });
    const homeData = reactive({
      deviceListS: [],
      deviceList: [],
      scaleIcon: 0.3,
      pixelOffsetY: 20,
      labelFont: "15px",
      textShow: [false],
      allTextShow: false,
      deviceShow: false,
      camera: {
        position: {
          lng: 108.06,
          lat: 32.67,
          height: 22700000
        },
        heading: 360,
        pitch: -90,
        roll: 0
      }
    });
    const measurementFabOptions = ref({
      direction: 'left',
      modelValue: false,
      color: 'primary'
    });
    const onClicked = item => {
      console.log(item);
    };
    const onDBClicked = (item, index) => {
      console.log("双击跳转路由");
      console.log(item);
      console.log(index);
      console.log(homeData.deviceList);
      item = homeData.deviceList[index];
      currentRow.value = item;
      permissionStore.setIndexCamera({
        position: view.value.camera.position
      });
      permissionStore.setIndexIcon({
        scaleIcon: homeData.scaleIcon,
        labelFont: homeData.labelFont,
        pixelOffsetY: homeData.pixelOffsetY,
        checkedTypes: checkedTypes.value
      });
      let arr = ['0', '1', '2'];
      if (item.deviceType === "11" || item.deviceType === "12" || item.deviceType === "13" || item.deviceType === "4") {
        if (item.deviceName !== undefined && item.channelId !== undefined) {
          closeDialog();
          deviceVideoPlay({
            deviceName: item.deviceName,
            channelId: item.channelId,
            deviceType: item.deviceType
          }).then(response => {
            video.value.open = true;
            video.value.title = item.name;
            if (response.code === 200 && response.msg === '操作成功') {
              video.value.url = response.data.wss_flv;
            } else {
              video.value.url = "";
            }
          });
        } else {
          proxy.$modal.msgWarning("该设备未设置设备编码和设备通道");
        }
      } else if (arr.includes(item.deviceType)) {
        getTasking({
          aircraft: item.id
        }).then(response => {
          if ("No Task" === response.msg) {
            proxy.$modal.msgWarning("当前设备未执行任务！！！");
            return;
          }
          router.push({
            path: '/task',
            state: {
              id: item.id,
              type: item.deviceType,
              isTasking: response.data
            }
          });
        });

        //跳转任务视图
      } else if (item.deviceType === "3") {
        router.push({
          path: '/task',
          state: {
            id: item.id,
            type: item.deviceType,
            isTasking: true
          }
        });
      }
    };

    // 关闭窗口
    function closeDialog() {
      video.value.title = '';
      video.value.url = "";
      video.value.open = false;
    }
    /* 3. 拉最新数据方法 */
    const getLastWeather = () => {
      if (!currentRow.value?.uid) return;
      getLastPoleWeather(currentRow.value.uid).then(res => {
        currentRow.value.poleWeatherHistory = res.data;
        console.log("调用后台查询气象数据接口");
      });
    };
    const getList = () => {
      getHomeList().then(response => {
        homeData.deviceListS = response.data;
        homeData.deviceList = [];
        let i = 0;
        for (let deviceInfo of homeData.deviceListS) {
          let aa = '';
          let arr = ['0', '1', '2'];
          if (arr.indexOf(deviceInfo.deviceType) > -1) {
            aa = '设备名称：' + deviceInfo.name + '\n数据链路：\t' + (deviceInfo.statusAll.flightDataStatus === 1 ? '在线' : '离线') + '\n吊舱视频：\t' + (deviceInfo.statusAll.podStatus === 1 ? '在线' : '离线') + '\n天线状态：\t' + (deviceInfo.statusAll.satcomStatus === 1 ? '在线' : '离线');
          } else if (deviceInfo.deviceType === "3") {
            aa = '设备名称：' + deviceInfo.name + '\n吊舱视频：\t' + (deviceInfo.statusAll.podStatus === 1 ? '在线' : '离线') + '\n天线状态：\t' + (deviceInfo.statusAll.satcomStatus === 1 ? '在线' : '离线');
          } else {
            aa = '设备名称：' + deviceInfo.name + '\n视频状态：\t' + (deviceInfo.statusAll.podStatus === 1 ? '在线' : '离线');
          }
          deviceInfo.text = aa;
          let label = "";
          let sumStatus = deviceInfo.statusAll.flightDataStatus + deviceInfo.statusAll.podStatus + deviceInfo.statusAll.satcomStatus;
          sumStatus > 0 ? label = "-green.png" : label = "-grey.png";
          deviceInfo.icon = "./icon/index/png/" + proxy.getDeviceIcon(deviceInfo.deviceType) + label;
          if (deviceInfo.longitude && deviceInfo.latitude && checkedTypes.value.includes(deviceInfo.deviceType)) {
            homeData.deviceList.push(deviceInfo);
            homeData.textShow[i] = false;
            i++;
          }
        }
        console.log("homeData.deviceList:", homeData.deviceList);
      });
      getDicts("device_type").then(response => {
        let arr = ['0', '1', '2', '3', '4', '12', '13', '14'];
        devicesOptions.value = [];
        response.data.map(item => {
          if (arr.includes(item.dictValue)) {
            devicesOptions.value.push(item);
          }
        });
        console.log(devicesOptions.value);
      });
    };
    const changeTextShow = index => {
      if (index === -1) {
        homeData.allTextShow = !homeData.allTextShow;
        for (let i = 0; i < homeData.textShow.length; i++) {
          homeData.textShow[i] = homeData.allTextShow;
        }
      } else {
        homeData.textShow[index] = !homeData.textShow[index];
      }
    };
    function changeDeviceShow() {
      homeData.deviceShow = !homeData.deviceShow;
    }
    function handleCheckedTypesChange(value) {
      homeData.deviceList = [];
      let i = 0;
      for (let deviceInfo of homeData.deviceListS) {
        let label = "";
        let sumStatus = deviceInfo.statusAll.flightDataStatus + deviceInfo.statusAll.podStatus + deviceInfo.statusAll.satcomStatus;
        sumStatus > 0 ? label = "-green.png" : label = "-grey.png";
        deviceInfo.icon = "./icon/index/png/" + proxy.getDeviceIcon(deviceInfo.deviceType) + label;
        if (deviceInfo.longitude && deviceInfo.latitude && value.includes(deviceInfo.deviceType)) {
          homeData.deviceList.push(deviceInfo);
          homeData.textShow[i] = false;
          i++;
        }
      }
    }
    const onViewerReady = ({
      Cesium,
      viewer
    }) => {
      map.value = Cesium;
      view.value = viewer;
      const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      handler.setInputAction(wheelment => {
        // TODO
        let alt = (viewer.camera.positionCartographic.height / 1000).toFixed(2);
        let height = viewer.camera.positionCartographic.height;
        console.log(height);
        if (height < 50000) {
          homeData.scaleIcon = 0.9;
          homeData.labelFont = "40px";
          homeData.pixelOffsetY = 50;
        } else if (height >= 50000 && height < 100000) {
          homeData.scaleIcon = 0.9;
          homeData.labelFont = "35px";
          homeData.pixelOffsetY = 40;
        } else if (height >= 100000 && height < 500000) {
          homeData.scaleIcon = 0.8;
          homeData.labelFont = "30px";
          homeData.pixelOffsetY = 35;
        } else if (height >= 500000 && height < 2000000) {
          homeData.scaleIcon = 0.6;
          homeData.labelFont = "20px";
          homeData.pixelOffsetY = 25;
        } else if (height >= 2000000) {
          homeData.scaleIcon = 0.4;
          homeData.labelFont = "15px";
          homeData.pixelOffsetY = 20;
        } else if (height >= 4000000) {
          homeData.scaleIcon = 0.3;
          homeData.labelFont = "15px";
          homeData.pixelOffsetY = 20;
        }
        console.log(homeData);
        if (alt < 7504.713) {
          cVisible.value = false;
        } else {
          cVisible.value = true;
        }
        callbackFunc();
      }, Cesium.ScreenSpaceEventType.WHEEL);

      /*  const blueBox = viewer.entities.add({
          name: "Blue box",
          position: Cesium.Cartesian3.fromDegrees(-114.0, 40.0, 300000.0),
          box: {
            dimensions: new Cesium.Cartesian3(400000.0, 300000.0, 500000.0),
            material: Cesium.Color.BLUE,
          },
        });*/
      viewer._container.style.cursor = "pointer";
      viewer.scene.globe.enableLighting = true;
      cVisible.value = true;
      //viewer.scene.globe.depthTestAgainstTerrain = true;
      // 最小缩放高度（米）
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = 0;
      // 最大缩放高度（米）
      viewer.scene.screenSpaceCameraController.maximumZoomDistance = 50000000;
      if (permissionStore.indexCamera === undefined) {
        setTimeout(() => {
          view.value.camera.flyTo({
            destination: map.value.Cartesian3.fromDegrees(104.16275, 33.58946, 5000000.0),
            orientation: {
              heading: map.value.Math.toRadians(0),
              // east, default value is 0.0 (north) //东西南北朝向
              pitch: map.value.Math.toRadians(-90),
              // default value (looking down)  //俯视仰视视觉
              roll: 0.0 // default value
            },
            duration: 3 //3秒到达战场
          });
          callbackFunc();
          cVisible.value = false;
        }, 3000);
      } else {
        checkedTypes.value = permissionStore.indexIcon.checkedTypes;
        handleCheckedTypesChange(permissionStore.indexIcon.checkedTypes);
        homeData.camera = permissionStore.indexCamera;
        homeData.scaleIcon = permissionStore.indexIcon.scaleIcon;
        homeData.labelFont = permissionStore.indexIcon.labelFont;
        homeData.pixelOffsetY = permissionStore.indexIcon.pixelOffsetY;
        cVisible.value = false;
      }
      handler.setInputAction(function (event) {
        callbackFunc();
      }, Cesium.ScreenSpaceEventType.LEFT_UP);
    };
    function callbackFunc() {
      // 视高 m
      //let alt = (view.value.camera.positionCartographic.height).toFixed(2);
      // 方位角
      //let heading = map.value.Math.toDegrees(view.value.camera.heading).toFixed(2);
      // 俯仰角
      //let pitch = map.value.Math.toDegrees(view.value.camera.pitch).toFixed(2);
      // 翻滚角
      //let roll = map.value.Math.toDegrees(view.value.camera.roll).toFixed(2);
      //var position = view.value.scene.camera.positionCartographic;
      // 弧度转经纬度
      //var lng = map.value.Math.toDegrees(position.longitude).toFixed(5);
      //var lat = map.value.Math.toDegrees(position.latitude).toFixed(5);
      //var height = position.height;
      //let str = `视高：${height}m  方位角：${heading}° 俯仰角：${pitch}° 翻滚角：${roll}° 经度：${lng} 纬度：${lat}`;
      //console.log(str);
      permissionStore.setIndexCamera({
        position: view.value.camera.position
      });
    }
    const querySearch = (queryString, cb) => {
      const restaurants = homeData.deviceList;
      const results = queryString ? restaurants.filter(device => {
        return device.name.toLowerCase().indexOf(queryString.toLowerCase()) != -1;
      }) : restaurants;
      cb(results);
    };
    function selectOneAddr(item) {
      if (item.longitude && item.latitude) {
        homeData.deviceList = homeData.deviceList.map(tmp => {
          if (tmp.id === item.id) {
            tmp.isFlag = true;
          } else {
            tmp.isFlag = false;
          }
          return tmp;
        });
        view.value.camera.flyTo({
          destination: map.value.Cartesian3.fromDegrees(item.longitude, item.latitude, 100.0),
          orientation: {
            heading: map.value.Math.toRadians(0),
            // east, default value is 0.0 (north) //东西南北朝向
            pitch: map.value.Math.toRadians(-90),
            // default value (looking down)  //俯视仰视视觉
            roll: 0.0 // default value
          },
          duration: 3 //3秒到达战场
        });
        homeData.scaleIcon = 0.8;
        homeData.labelFont = "40px";
        homeData.pixelOffsetY = 50;
        cVisible.value = false;
        permissionStore.setIndexCamera({
          position: view.value.camera.position
        });
        permissionStore.setIndexIcon({
          scaleIcon: homeData.scaleIcon,
          labelFont: homeData.labelFont,
          pixelOffsetY: homeData.pixelOffsetY,
          checkedTypes: checkedTypes.value
        });
      } else {
        proxy.$modal.msgWarning("该设备未设置经纬度");
      }
    }
    let timer1 = undefined;
    let timer2 = undefined;
    let timer = null;
    onMounted(() => {
      getList();
      if (permissionStore.indexCamera === undefined) {
        timer2 = setInterval(e => {
          show.value = !show.value;
        }, 600);
      } else {
        show.value = false;
      }
      timer1 = setInterval(getList, 60000);
    });
    /* 1. 监听当前行变化（打开弹窗/切换设备） */
    watch(() => currentRow.value?.uid, newVal => {
      // 先清掉旧定时器
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      // 有值才启动轮询
      if (newVal) {
        timer = setInterval(getLastWeather, 60 * 1000);
        // 立即执行一次
        getLastWeather();
      }
    }, {
      immediate: true
    });
    onUnmounted(() => {
      if (timer) clearInterval(timer);
      clearInterval(timer1);
      clearInterval(timer2);
    });
    return (_ctx, _cache) => {
      const _component_vc_graphics_billboard = _resolveComponent("vc-graphics-billboard");
      const _component_vc_graphics_label = _resolveComponent("vc-graphics-label");
      const _component_vc_entity = _resolveComponent("vc-entity");
      const _component_vc_imagery_provider_tianditu = _resolveComponent("vc-imagery-provider-tianditu");
      const _component_vc_layer_imagery = _resolveComponent("vc-layer-imagery");
      const _component_vc_navigation = _resolveComponent("vc-navigation");
      const _component_vc_distance_legend = _resolveComponent("vc-distance-legend");
      const _component_vc_measurements = _resolveComponent("vc-measurements");
      const _component_el_autocomplete = _resolveComponent("el-autocomplete");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_vc_viewer = _resolveComponent("vc-viewer");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_vc_viewer, {
        ref: "viewerRef",
        onReady: onViewerReady,
        shouldAnimate: true,
        "info-box": false,
        "show-credit": false,
        camera: _unref(homeData).camera
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeData).deviceList, (item, index) => {
          return _openBlock(), _createBlock(_component_vc_entity, {
            key: index,
            ref_for: true,
            ref: "entity",
            position: {
              lng: item.longitude,
              lat: item.latitude,
              height: 5.0
            },
            onClick: $event => onDBClicked(item, index),
            onDblclick: $event => onDBClicked(item, index),
            onMouseover: $event => changeTextShow(index),
            onMouseout: $event => changeTextShow(index)
          }, {
            default: _withCtx(() => [_createVNode(_component_vc_graphics_billboard, {
              ref_for: true,
              ref: "billboard",
              image: item.icon,
              scale: item.isFlag ? 1 : _unref(homeData).scaleIcon,
              heightReference: item.isFlag ? 1 : 0
            }, null, 8, ["image", "scale", "heightReference"]), _createVNode(_component_vc_graphics_label, {
              text: item.name,
              font: _unref(homeData).labelFont,
              pixelOffset: [0, _unref(homeData).pixelOffsetY],
              "show-background": true,
              backgroundColor: "rgba(35, 102, 169, 0.7)",
              heightReference: item.isFlag ? 1 : 0
            }, null, 8, ["text", "font", "pixelOffset", "heightReference"])]),
            _: 2
          }, 1032, ["position", "onClick", "onDblclick", "onMouseover", "onMouseout"]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeData).deviceList, (item, index) => {
          return _openBlock(), _createBlock(_component_vc_entity, {
            key: index,
            ref_for: true,
            ref: "entity",
            position: {
              lng: item.longitude,
              lat: item.latitude,
              height: 5.0
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_vc_graphics_label, {
              text: item.text,
              font: "15px sans-serif",
              pixelOffset: [60 * (_unref(homeData).scaleIcon + 0.3), 0],
              "show-background": true,
              backgroundColor: "rgba(6, 81, 133, 0.9)",
              horizontalOrigin: 1,
              scale: _unref(homeData).scaleIcon + 0.3,
              show: _unref(homeData).textShow[index]
            }, null, 8, ["text", "pixelOffset", "scale", "show"])]),
            _: 2
          }, 1032, ["position"]);
        }), 128)), _createVNode(_component_vc_layer_imagery, null, {
          default: _withCtx(() => [_createVNode(_component_vc_imagery_provider_tianditu, {
            token: _unref(token),
            "map-style": "img_w"
          }, null, 8, ["token"])]),
          _: 1
        }), _createVNode(_component_vc_layer_imagery, null, {
          default: _withCtx(() => [_createVNode(_component_vc_imagery_provider_tianditu, {
            token: _unref(token),
            "map-style": "cia_c"
          }, null, 8, ["token"])]),
          _: 1
        }), _createVNode(_component_vc_navigation, {
          ref: "navigation",
          offset: [10, 145],
          printOpts: false,
          locationOpts: false
        }, null, 512), _createVNode(_component_vc_distance_legend, {
          position: "bottom-right",
          offset: [10, 65]
        }), _createVNode(_component_vc_measurements, {
          position: "top-right",
          "main-fab-opts": _unref(measurementFabOptions),
          offset: [50, 75]
        }, null, 8, ["main-fab-opts"]), _unref(cVisible) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "topWeixin"
        }, [_createElementVNode("img", {
          src: _imports_0
        })], -1)), _withDirectives(_createElementVNode("div", _hoisted_4, [...(_cache[5] || (_cache[5] = [_createElementVNode("img", {
          src: _imports_1
        }, null, -1)]))], 512), [[_vShow, _unref(show)]])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_autocomplete, {
          modelValue: _unref(searchkey),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(searchkey) ? searchkey.value = $event : null),
          "value-key": "name",
          "fetch-suggestions": querySearch,
          "trigger-on-focus": false,
          clearable: "",
          placeholder: "载体名称",
          onSelect: selectOneAddr
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = $event => changeDeviceShow())
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("img", {
          style: {
            "height": "2.2rem",
            "width": "2.2rem",
            "margin-left": "0.5rem"
          },
          src: _imports_2
        }, null, -1), _createElementVNode("div", {
          style: {
            "color": "#FFFFFF",
            "margin-left": "0.5rem"
          }
        }, "图层", -1)]))]), _createElementVNode("div", {
          style: {
            "margin-top": "1rem"
          },
          onClick: _cache[2] || (_cache[2] = $event => changeTextShow(-1))
        }, [...(_cache[8] || (_cache[8] = [_createElementVNode("img", {
          style: {
            "height": "2.2rem",
            "width": "2.2rem",
            "margin-left": "0.5rem"
          },
          src: _imports_2
        }, null, -1), _createElementVNode("div", {
          style: {
            "color": "#FFFFFF",
            "margin-left": "0.5rem"
          }
        }, "信息", -1)]))])]), _unref(homeData).deviceShow ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_checkbox_group, {
          modelValue: _unref(checkedTypes),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(checkedTypes) ? checkedTypes.value = $event : null),
          onChange: handleCheckedTypesChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(devicesOptions), (item, index) => {
            return _openBlock(), _createBlock(_component_el_checkbox, {
              key: index,
              label: item.dictValue
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.dictLabel), 1)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["camera"]), _unref(video).open ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        title: _unref(video).title,
        modelValue: _unref(video).open,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(video).open = $event),
        width: "100rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: closeDialog,
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_unref(currentRow)?.poleWeatherHistory ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "weather-header"
        }, "实时气象", -1)), _createElementVNode("div", _hoisted_10, [_cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "label"
        }, "设备名称", -1)), _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(currentRow).name), 1)]), _createElementVNode("div", _hoisted_12, [_cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "label"
        }, "设备编号", -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(currentRow).uid), 1)]), _createElementVNode("div", _hoisted_14, [_cache[11] || (_cache[11] = _createElementVNode("span", {
          class: "label"
        }, "风速", -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(currentRow).poleWeatherHistory.windSpeed) + " m/s", 1)]), _createElementVNode("div", _hoisted_16, [_cache[12] || (_cache[12] = _createElementVNode("span", {
          class: "label"
        }, "风向", -1)), _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(currentRow).poleWeatherHistory.windDir), 1)]), _createElementVNode("div", _hoisted_18, [_cache[13] || (_cache[13] = _createElementVNode("span", {
          class: "label"
        }, "风力", -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(currentRow).poleWeatherHistory.windLevel) + " 级", 1)]), _createElementVNode("div", _hoisted_20, [_cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "label"
        }, "湿度", -1)), _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(currentRow).poleWeatherHistory.humidity) + "%", 1)]), _createElementVNode("div", _hoisted_22, [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "label"
        }, "温度", -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(currentRow).poleWeatherHistory.temperature) + " ℃", 1)]), _createElementVNode("div", _hoisted_24, [_cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "label"
        }, "噪声", -1)), _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(currentRow).poleWeatherHistory.noise) + " dB", 1)]), _createElementVNode("div", _hoisted_26, [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "label"
        }, "气压", -1)), _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(currentRow).poleWeatherHistory.pressure) + " Kpa", 1)]), _createElementVNode("div", _hoisted_28, [_cache[18] || (_cache[18] = _createElementVNode("span", {
          class: "label"
        }, "累计雨量", -1)), _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(currentRow).poleWeatherHistory.rainfall) + " mm", 1)]), _createElementVNode("div", _hoisted_30, [_cache[19] || (_cache[19] = _createElementVNode("span", {
          class: "label"
        }, "时间", -1)), _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(currentRow).poleWeatherHistory.createTime), 1)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(_unref(currentRow).poleWeatherHistory.rainfall < 10 && _unref(currentRow).poleWeatherHistory.windSpeed < 10 ? "无人机可以正常作业" : "无人机作业条件需要现场确认，谨慎飞行"), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_34, [!_unref(video).url ? (_openBlock(), _createElementBlock("div", _hoisted_35, "暂无推流信息")) : (_openBlock(), _createBlock(Player, {
          key: 1,
          ref: "playerRef",
          url: _unref(video).url,
          fluent: "",
          autoplay: ""
        }, null, 8, ["url"]))])])]),
        _: 1
      }, 8, ["title", "modelValue"])) : _createCommentVNode("", true)])]);
    };
  }
};